import { useAuth } from '@clerk/clerk-react';
import { useCallback } from 'react';

export const useGetAuthToken = () => {
	const { getToken } = useAuth();

	return useCallback(() => {
		return getToken({ template: 'trustform' });
	}, [getToken]);
};
